import { RecruitingTools } from "pages/RecruitingTools"

/** Evo Recruiting “Candidates” experience with Volition candidate APIs. */
export const VivintCandidates = () => <RecruitingTools apiVariant="vivint" />
